import { render } from "./SearchPage.vue?vue&type=template&id=6f6e1720&ts=true"
import script from "./SearchPage.vue?vue&type=script&lang=ts"
export * from "./SearchPage.vue?vue&type=script&lang=ts"

import "./SearchPage.vue?vue&type=style&index=0&id=6f6e1720&lang=sass"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__